import { BaseRouteService } from 'core/services';

class ImportDetailRouteService extends BaseRouteService {
    constructor() {
        super('import-details');
    }

    update(resource){
        return super.update(this.base + '/group-items', resource);
    }

    findItemGroup(resource){
        return super.find(this.base + '/group-items/shared-data/{patientKey}/{itemGroupId}', resource);
    }

    isRunning(resource){
        return super.find(this.base + '/is-running/{importHeaderId}', resource);
    }

    find(filter) {
        return super.find(this.base + '/{?searchQuery,page,rpp,sort,embed,fields,importHeaderId}', filter);
    }

    findGroupedByPatients(filter) {
        return super.find(this.base + '/patient/{?searchQuery,page,rpp,sort,embed,fields,importHeaderId}', filter);
    }

    getByPatient(resource){
        return super.get(this.base + '/{importHeaderId}/patient/{patientGroupId}/{?embed,fields}', null, resource);
    }

    import(resource){
        return super.update(this.base + '/import/{importHeaderId}/{patientKey}', resource);
    }

    process(resource){
        return super.update(this.base + '/process/{importHeaderId}/{patientKey}', resource);
    }

    importAll(resource){
        return super.update(this.base + '/import-all/{importHeaderId}', resource);
    }

    batchUpdate(resource) {
        return super.batchUpdate(this.base + '/batch', resource);
    }

    usePatient(resource){
        return super.update(this.base + '/use-patient/{?importHeaderId,patientGroupId,patientId}', resource);
    }

    updateReviewed(resource){
        return super.update(this.base + '/reviewed', resource);
    }

    getPatientNavigation(filter) {
		return super.find(`${this.base}/patient-navigation/{?importHeaderId,patientGroupId}`, filter);
	}

}

export default ImportDetailRouteService;
